import React from "react";

const rajvee_shah = () => {
  return (
    <div>
      <h1>Rajvee Shah</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was an online aptitude test after which 25 candidates were
        shortlisted for interviews. The cgpa criteria was 7.5. Hilti had arrived
        during the early stages of recruitment around mid July.{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There were 2 rounds - One technical and one HR. The Technical Interview
        consisted of questions on Data Structures and Algorithms, Object
        Oriented Programming and related concepts. About 10 students were
        shortlisted for the HR round and finally 4 CS students were offered
        internships.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round consisted of questions on DSA, OOPS, Java and other
        related concepts. There were 2 coding questions of medium difficulty.
        One was a circular queue based question and the other one involved bit
        manipulation. The mcq’s were relatively easy and can be solved easily
        with basic preparation.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the Aptitude round, 25 students were shortlisted for interviews
        based on the test scores. The coding questions carried maximum marks, so
        solving the coding questions completely will basically ensure your
        shortlisting. Make sure to attempt all the mcq’s as well because that
        will add up to your total score.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        As far as I remember, I had 2 days before my interview was scheduled.
        This was a very crucial period, because with limited time in hand, you
        are supposed to revise too much. I made sure I was thorough with every
        word on my resume and made sure I knew all my projects very well. The
        tech stack used in your projects, why you implemented a feature in a
        particular way, or which other ways of implementation could be thought
        of, are some questions you need to prepared for. I would say, be very
        thorough with your resume, revise basic DSA concepts like searching,
        sorting, and algorithms like BFS, DFS and some easy-mid level leetcode
        questions on arrays, linked lists and trees so that you remain in touch
        with coding. During this time, prepare your best to showcase what you
        are good at and catch up on things you think are important. Don’t look
        at what are others are preparing and jump on new things before your
        interviews, it makes you lose confidence. Brush up on your communication
        skills and make sure you communicate your thoughts to the interviewer
        clearly without hesitating. Take enough rest and relax, you will do it!
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 rounds - One technical and One HR.
        <br />
        The technical round was a good in-depth discussion on DSA and OOP
        concepts. I was asked the following questions -
      </p>

      <ol>
        <li>Differences between trees and graphs </li>
        <li>How to add a node ( a give number ) in a BST </li>
        <li>Dijsktra and A-star algorithm and which one’s better? </li>
        <li>
          The algorithm for finding out the Minimum spanning tree ( Prims and
          Kruskal’s Algorithm ){" "}
        </li>
        <li>
          2 puzzles on logic building. You can find examples on gfg articles and
          IndiaBix.{" "}
        </li>
        <li>
          I was also asked to write the java code for checking if a given string
          is a balanced parenthesis or not ( the stack solution ){" "}
        </li>
        <li>4 pillars of OOP and their real-life applications </li>
        <li>
          UML diagrams and their types. I could only recall class, state, and
          object diagrams after which I was asked to explain the differences
          between them.{" "}
        </li>
        <li>
          I was asked about inheritance in great depth and how it is different
          in different languages like Java and CPP.
        </li>
      </ol>

      <p>
        After the technical interview, about 10 students were shortlisted for
        the HR round. The HR round was quite chill. It involved questions around
        my family background, extra curricular activities, and company values.
        This round is basically to understand you as a person beyond your
        technical pursuits. Talk calmly and confidently to the interviewer. They
        might ask you why you chose COEP, why a particular club, why do you want
        to join Hilti, did you attend the company’s PPT? Make sure you give
        short, precise and satisfactory answers to these basic questions!
        <br />
        If you make it to the HR round, there are high chances you may get the
        offer!{" "}
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The technical questions were mostly focussed on DSA and puzzles. I was
        asked no questions on DBMS, OS, Networks or System Design. The panel was
        only interested in my DSA and problem solving skills. They were
        interested in understanding the approach behind the problem, the data
        structure which I used, and why not any other data structure, the
        algorithm I used, its time complexity and how could it be optimsed. That
        is the correct flow you must follow while answering questions - brute -&gt;
        better -&gt; optimal.
        <br />
        Once you present a solution, you will most likely be asked to optimize
        the solution. If you are not able to think of an optimal solution right
        away, you can always ask for time and think out loud so that they know
        your thought process!
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA-
      </p>

      <ol>
        <li>Striver’s A to Z DSA sheet </li>
        <li>Abdul Bari’s Youtube Playlist for Algorithms </li>
        <li>NeetCode solutions</li>
      </ol>

      <p>
        Try to solve one DSA Leetcode question daily, understand the solution
        clearly. Keep revising past questions and their solutions so that you
        keep in touch with the approach you had used. Make sure you stick to one
        platform and one sheet. Don’t switch resources continuously as they
        contain almost the same questions. Be confident and don’t give vague
        answers during the interviews! If you don’t know an answer, do not lie
        or fake a solution, you will most likely get caught and it will leave a
        bad impression on the interviewer.{" "}
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Be consistent in solving DSA questions and keep revising your past
        questions. It is okay to feel overwhelmed with a plethora of new
        questions available on the internet. Try to make a schedule for Daily
        DSA practice and stick to it. Your consistency and Persistence will
        surely reward you in the long run! Try to strike a good balance between
        your college studies and Internship prep to make sure you don’t
        overburden yourself later. Try to attempt weekly contests on Codeforces
        and Codechef to keep up with Competitive Programming. Read GFG articles
        on questions if you don’t understand a solution completely. TRY not to
        use Ghatgpt or any other AI to help you with coding in the early stages
        because it kills your ability to think on your own. Do not paste your
        solutions on gpt to optimise them, think on your own or ask your
        friends, that will help you in the long run!
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I was asked about my Extra curriculars in the HR round but
        nothing much beyond that! You should be able to clearly answer those
        questions because they judge your personality on the basis of how you
        justify your choices and hobbies.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        It is a long journey. Start preparing early, don’t waste your summer
        vacation. Start solving DSA regularly if you haven’t already! Don’t
        stress yourself too much or invite anxiety. Make sure you focus on your
        physical health also, exercise for an hour daily, keep talking to
        friends and family whenever you feel sad or depressed. DO NOT compare
        yourself to other poeple who have landed offers because it makes you
        lose confidence, Trust god’s plan and keep calm, you will get a good
        internship!!
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Be yourself, keep calm, trust the divine, work hard, practice enough and
        you will eventually get what you want!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 8329313989
        <br />
        <strong>Email :</strong> <a href="mailto:srajvee205@gmail.com">srajvee205@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/rajvee-shah-6a4904284/">
          Rajvee Shah
        </a>
      </p>
    </div>
  );
};

export default rajvee_shah;
